import { v4 as uuidv4 } from 'uuid';
import i18n from '@/i18n';
import moment from 'moment';

export class ErrorMessage {
    public id: string;
    public timestamp: string;
    constructor(
        public error: Error,
        public message: string = i18n.t('errorOccured') as string,
        public timeout: number = 0,
        public showDetails?: boolean,
    ) {
        this.id = uuidv4();
        this.timestamp = moment().toISOString();
        this.showDetails = showDetails ?? true;
    }
}
